export const Data = {
  programming: {
    package1: {
      title_en: "Sites",
      title_ar: "مواقع",
      price: 250,
      content: [
        {
          id: 1,
          title_en: "Add more languages",
          title_ar: " اضافة لغات اكثر  ",
          price: 10,
        },
        {
          id: 2,
          title_en: "Add more languages",
          title_ar: " اضافة لغات اكثر  ",
          price: 20,
        },
        {
          id: 3,
          title_en: "Add more languages",
          title_ar: " اضافة لغات اكثر  ",
          price: 30,
        },
        {
          id: 4,
          title_en: "Add more languages",
          title_ar: " اضافة لغات اكثر  ",
          price: 40,
        },
        {
          id: 5,
          title_en: "Add more languages",
          title_ar: " اضافة لغات اكثر  ",
          price: 50,
        },
      ],
    },
    package2: {
      title_en: "Sites",
      title_ar: "مواقع",
      price: 250,
      content: [
        {
          id: 6,
          title_en: "Add more languages",
          title_ar: " اضافة لغات اكثر  ",
          price: 60,
        },
        {
          id: 7,
          title_en: "Add more languages",
          title_ar: " اضافة لغات اكثر  ",
          price: 70,
        },
        {
          id: 8,
          title_en: "Add more languages",
          title_ar: " اضافة لغات اكثر  ",
          price: 80,
        },
        {
          id: 9,
          title_en: "Add more languages",
          title_ar: " اضافة لغات اكثر  ",
          price: 90,
        },
        {
          id: 10,
          title_en: "Add more languages",
          title_ar: " اضافة لغات اكثر  ",
          price: 100,
        },
      ],
    },
    package3: {
      title_en: "Sites",
      title_ar: "مواقع",
      price: 250,
      content: [
        {
          id: 11,
          title_en: "Add more languages",
          title_ar: " اضافة لغات اكثر  ",
          price: 110,
        },
        {
          id: 12,
          title_en: "Add more languages",
          title_ar: " اضافة لغات اكثر  ",
          price: 120,
        },
        {
          id: 13,
          title_en: "Add more languages",
          title_ar: " اضافة لغات اكثر  ",
          price: 130,
        },
        {
          id: 14,
          title_en: "Add more languages",
          title_ar: " اضافة لغات اكثر  ",
          price: 140,
        },
        {
          id: 15,
          title_en: "Add more languages",
          title_ar: " اضافة لغات اكثر  ",
          price: 150,
        },
      ],
    },
  },
  design: {
    package1: {
      title_en: "Sites",
      title_ar: "مواقع",
      price: 250,
      content: [
        {
          id: 16,
          title_en: "Add more languages",
          title_ar: " اضافة لغات اكثر  ",
          price: 160,
        },
        {
          id: 17,
          title_en: "Add more languages",
          title_ar: " اضافة لغات اكثر  ",
          price: 170,
        },
        {
          id: 18,
          title_en: "Add more languages",
          title_ar: " اضافة لغات اكثر  ",
          price: 180,
        },
        {
          id: 19,
          title_en: "Add more languages",
          title_ar: " اضافة لغات اكثر  ",
          price: 190,
        },
        {
          id: 20,
          title_en: "Add more languages",
          title_ar: " اضافة لغات اكثر  ",
          price: 200,
        },
      ],
    },
    package2: {
      title_en: "Sites",
      title_ar: "مواقع",
      price: 250,
      content: [
        {
          id: 21,
          title_en: "Add more languages",
          title_ar: " اضافة لغات اكثر  ",
          price: 210,
        },
        {
          id: 22,
          title_en: "Add more languages",
          title_ar: " اضافة لغات اكثر  ",
          price: 220,
        },
        {
          id: 23,
          title_en: "Add more languages",
          title_ar: " اضافة لغات اكثر  ",
          price: 230,
        },
        {
          id: 24,
          title_en: "Add more languages",
          title_ar: " اضافة لغات اكثر  ",
          price: 240,
        },
        {
          id: 25,
          title_en: "Add more languages",
          title_ar: " اضافة لغات اكثر  ",
          price: 250,
        },
      ],
    },
    package3: {
      title_en: "Sites",
      title_ar: "مواقع",
      price: 250,
      content: [
        {
          id: 26,
          title_en: "Add more languages",
          title_ar: " اضافة لغات اكثر  ",
          price: 260,
        },
        {
          id: 27,
          title_en: "Add more languages",
          title_ar: " اضافة لغات اكثر  ",
          price: 270,
        },
        {
          id: 28,
          title_en: "Add more languages",
          title_ar: " اضافة لغات اكثر  ",
          price: 280,
        },
        {
          id: 29,
          title_en: "Add more languages",
          title_ar: " اضافة لغات اكثر  ",
          price: 290,
        },
        {
          id: 30,
          title_en: "Add more languages",
          title_ar: " اضافة لغات اكثر  ",
          price: 300,
        },
      ],
    },
  },
};
